import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http'
import { translation, TranslationObject } from './store/i18n.interface';

@Injectable({
  providedIn: 'root'
})
export class I18nService {

  constructor(private http: HttpClient) { }

  fetchAvaliableLangList(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/lang/list`
    return this.http.get(url)
  }

  fetchTranslations(iso2code: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/lang/trn/${iso2code}`
    return this.http.get(url)
  }

  fetchDefaultTranslations(): Observable<translation> {
    return this.http.get<translation>(`/assets/i18n/en.json`)
  }

  fetchTranslationsList(params, iso2code): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/translation/${iso2code}/list`;
    return this.http.post(url, params);
  }

  updateKey(translation: TranslationObject, iso2code: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/translation/${iso2code}`

    return this.http.put(url, translation)
  }

  deleteKey(key: string, iso2code: string) {
    const url = `${environment.API_ENDPOINT}/admin/translation/${iso2code}/${key}`

    return this.http.delete(url)
  }

  exportTranslations(iso2code: string, defaultTranslations) {
    const url = `${environment.API_ENDPOINT}/admin/translation/${iso2code}/export`;
    return this.http.post(url, defaultTranslations, {
      observe: 'response',
      responseType: 'blob' as 'json',
    })
  }

  importTranslation(formData, iso2code: string) {
    const url = `${environment.API_ENDPOINT}/admin/translation/${iso2code}/import`;
    return this.http.put(url, formData)
  }



}
